var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/tabbar_camera.d2979bfa.png","uri@2x": __webpack_public_path__ + "static/media/tabbar_camera.04acac37.png","uri@3x": __webpack_public_path__ + "static/media/tabbar_camera.fc7b1c17.png",
    width: 24,
    height: 24
});